import { Stack } from "@mui/system";
import React from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../../../../Components/Bits/PageHeader";
import SubjectIcon from "@mui/icons-material/Subject";
import GroupsIcon from "@mui/icons-material/Groups";
import ElevatorIcon from "@mui/icons-material/Elevator";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import EditNotificationsIcon from "@mui/icons-material/EditNotifications";
import {
  Card,
  CardActionArea,
  Grid,
  LinearProgress,
  Typography,
} from "@mui/material";
import InsertLinkIcon from "@mui/icons-material/InsertLink";

import { CampaignContext } from "./components/CampaignContext";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import StyleIcon from "@mui/icons-material/Style";
import MoveDownIcon from "@mui/icons-material/MoveDown";

const ViewInboundCampaign = () => {
  const { id } = useParams();

  const [campaign, setCampaign] = React.useState({});

  let getCampaignById = useQuery({
    queryKey: ["getInboundCampaigns", id],
    queryFn: async () =>
      await axios.get(`${process.env.REACT_APP_API_URL}/QAInbound/admin/${id}`),
    onSuccess: (data) => {
      setCampaign(data?.data?.data);
    },
  });

  const navigate = useNavigate();

  const { pathname } = useLocation();

  const currentPath = pathname.split("/")[5];

  const Paths = [
    {
      name: "Queue Details",
      location: "ViewInboundCampaign",
      icon: <SubjectIcon size="small" />,
    },
    {
      name: "Teams",
      location: "Teams",
      icon: <GroupsIcon size="small" />,
    },
    {
      name: "Evaluations",
      location: "Evaluations",
      icon: <ElevatorIcon size="small" />,
    },
    {
      name: "Questions Groups",
      location: "QuestionsGroups",
      icon: <QuestionAnswerIcon size="small" />,
    },
    {
      name: "Campaign Linking",
      location: "CampaignLinking",
      icon: <InsertLinkIcon size="small" />,
    },
    {
      name: "Manage Question Tags",
      location: "ManageQuestionTags",
      icon: <StyleIcon size="small" />,
    },
    {
      name: "Move Evaluations",
      location: "MoveEvaluations",
      icon: <MoveDownIcon size="small" />,
    },
    {
      name: "Notifications Lists",
      location: "NotificationsLists",
      icon: <EditNotificationsIcon size="small" />,
    },
  ];

  if (getCampaignById?.isLoading) {
    return (
      <div>
        <LinearProgress />
      </div>
    );
  }

  return (
    <div>
      <PageHeader
        title="QA Admin"
        subheader="Manage your QA campaigns"
        breadcrumbs={[
          { title: "Home", href: "/" },
          { title: "QA Admin", href: "/CDA/inbound/admin" },
          { title: `QA Admin ${id}`, href: `/CDA/inbound/admin/${id}` },
        ]}
      />

      <Grid container spacing={1}>
        {Paths.map((path, index) => {
          return (
            <Grid item xs={2} key={index}>
              <Card
                sx={
                  currentPath === path.location
                    ? { borderStyle: "solid", borderColor: "secondary.main" }
                    : null
                }
              >
                <CardActionArea
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    py: 5,
                  }}
                  onClick={() => {
                    navigate(`${path.location}`);
                  }}
                >
                  <Stack direction="row" alignContent="center" spacing={1}>
                    {path.icon}
                    <Typography color="textPrimary">{path.name}</Typography>
                  </Stack>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      <Stack>
        <CampaignContext.Provider value={campaign}>
          <Outlet />
        </CampaignContext.Provider>
      </Stack>
    </div>
  );
};

export default ViewInboundCampaign;
